export * from './18_lnjyxx.component';